module.exports = __webpack_public_path__ + "img/makinota.909dd00d.jpg";